import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const isAdminLoggedIn = localStorage.getItem('admin_logged_in') === 'true';

    if (!isAdminLoggedIn) {
        return <Navigate to="/admin/login" replace />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
